import { NewTooltip } from '@lib/components'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  allowed: boolean
  teamProject: boolean
}

type ItemProps = Pick<Props, 'allowed'>

const DeleteItem: React.FC<ItemProps> = ({ allowed }) => (
  <DropdownMenu.Button
    disabled={!allowed}
    danger
    icon={Trash}
    id="delete"
    title="Delete"
  />
)

// In a team, a member may delete only the projects they created; everything
// else is for managers and the admin. A greyed-out Delete with no reason read
// as a bug (Help Scout 19308), so a team project says who can delete it.
// The wrapper takes the hover: a disabled button does not.
export const DeleteButton: React.FC<Props> = ({ allowed, teamProject }) => {
  if (allowed || !teamProject) {
    return <DeleteItem allowed={allowed} />
  }

  return (
    <NewTooltip
      content="Ask a team admin to delete"
      className={css.tooltip}
      position="right"
      renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
        <div
          ref={onSetRef}
          className={css.item}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <DeleteItem allowed={false} />
        </div>
      )}
    />
  )
}
